/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Start_L2Inputs */

const en_wc_tut_start_l2 = /** @type {(inputs: Wc_Tut_Start_L2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose Open to load an existing .docx, .doc, .odt, .rtf, .md or .txt file. Recent documents appear in the list below.`)
};

/**
* | output |
* | --- |
* | "Choose Open to load an existing .docx, .doc, .odt, .rtf, .md or .txt file. Recent documents appear in the list below." |
*
* @param {Wc_Tut_Start_L2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_start_l2 = /** @type {((inputs?: Wc_Tut_Start_L2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Start_L2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_start_l2(inputs)
});
export { wc_tut_start_l2 as "wc.tut.start.l2" }